import Image from "../../Global/Image/Image";
import Modal from "../../Common/Modal/Modal";
import VideoIFrame from "../../Common/VideoIFrame/VideoIFrame";
import { useImageZoom } from "../hooks/useImageZoom";
import "./ProductImageZoom.scss";

/**
 * Product image viewer with zoom/pan controls and video support
 */
const ProductImageZoom = ({
  mediaItems,
  activeMediaItem,
  productCatalogImageHeightOverride,
  productCatalogImageWidthOverride,
  videoUrl,
  showVideoModal,
  toggleVideoModal,
  productData,
  newLabel,
  proPlanetSustainableLabel,
  zoomInLabel,
  zoomOutLabel,
  panLeftLabel,
  panRightLabel,
  panUpLabel,
  panDownLabel,
}) => {
  const {
    activeImageRef,
    imageWrapperRef,
    imageZoomIn,
    imageZoomOut,
    imagePanLeft,
    imagePanRight,
    imagePanUp,
    imagePanDown,
    handleKeyDown,
    handleKeyUp,
    handleDragStart,
    handleDragEnd,
    handleDragging,
  } = useImageZoom();

  if (!productData || !mediaItems || mediaItems.length === 0) {
    return null;
  }

  return (
    <div
      ref={imageWrapperRef}
      className="pdp-header__active-image-zoom-wrapper"
      tabIndex={0}
      onMouseDown={handleDragStart}
      onMouseUp={handleDragEnd}
      onMouseMove={handleDragging}
      onKeyUp={handleKeyUp}
      onKeyDown={handleKeyDown}
      onMouseLeave={handleDragEnd}
    >
      {mediaItems.map((item, index) => {
        if (item.itemNum !== activeMediaItem) {
          return null;
        }

        // Video preview image
        if (item.isVideoPreviewImage) {
          return (
            <div key={`active-media__${index}`} className="pdp-header__active-image-wrapper">
              {item.imageUrl && (
                <Image
                  className="video-banner__image"
                  loading="eager"
                  src={item.imageUrl}
                  alt={item.altText}
                  height={productCatalogImageHeightOverride}
                  width={productCatalogImageWidthOverride}
                />
              )}
              <div className="video-banner__content-wrapper with-image">
                <button
                  className="video-banner__btn btn btn--play-video darticon-play"
                  onClick={toggleVideoModal}
                ></button>
              </div>
            </div>
          );
        }

        // Regular product image with zoom/pan controls
        return (
          <div key={`active-media__${index}`}>
            {/* Zoom controls */}
            <div className="pdp-header__imageControls left">
              <span className="pdp-header__imageControls__zoomControls">
                <button
                  onClick={imageZoomIn}
                  aria-label={zoomInLabel || "zoom in"}
                >
                  +
                </button>
                <button
                  onClick={imageZoomOut}
                  aria-label={zoomOutLabel || "zoom out"}
                >
                  -
                </button>
              </span>
            </div>

            {/* Pan controls */}
            <div className="pdp-header__imageControls right">
              <span className="pdp-header__imageControls__panControls">
                <button
                  onClick={imagePanUp}
                  title={panUpLabel || "pan up"}
                  aria-label={panUpLabel || "pan up"}
                  className="pan-arrow-up"
                ></button>
                <div>
                  <button
                    onClick={imagePanLeft}
                    title={panLeftLabel || "pan left"}
                    aria-label={panLeftLabel || "pan left"}
                    className="pan-arrow-left"
                  ></button>
                  <button
                    onClick={imagePanRight}
                    title={panRightLabel || "pan right"}
                    aria-label={panRightLabel || "pan right"}
                    className="pan-arrow-right"
                  ></button>
                </div>
                <button
                  onClick={imagePanDown}
                  title={panDownLabel || "pan down"}
                  aria-label={panDownLabel || "pan down"}
                  className="pan-arrow-down"
                ></button>
              </span>
            </div>

            {/* Main image */}
            <div className="pdp-header__active-image-wrapper">
              <Image
                imageRef={activeImageRef}
                className="pdp-header__active-image"
                loading="eager"
                src={item.imageUrl}
                alt={item.altText}
                height={productCatalogImageHeightOverride}
                width={productCatalogImageWidthOverride}
              />
            </div>
          </div>
        );
      })}

      {/* Product flags */}
      <div className="pdp-header__flag-section">
        {productData?.isNewProduct && (
          <span className="pdp-header__active-image-pdp-label">{newLabel}</span>
        )}
        {productData?.isProPlanet && (
          <p className="pdp-header__active-image-pdp-icon" aria-label={proPlanetSustainableLabel}>
            <img
              src="https://dart.widen.net/content/vsjmstuwtr/svg/ProPlanet-Leaf-CheckmarkwStroke-Green.svg?u=hsm95h"
              alt={proPlanetSustainableLabel}
            />
          </p>
        )}
      </div>

      {/* Video modal */}
      {videoUrl && (
        <Modal show={showVideoModal} handleClose={toggleVideoModal}>
          <VideoIFrame video={videoUrl} />
        </Modal>
      )}
    </div>
  );
};

export default ProductImageZoom;
